import { getBasePathWithTrailingSlash } from "../../../common/env.ts";

/**
 * Send this URL through the interstitial redirect page in order
 * to notify them of a site change and SSO them to their destination.
 *
 * This returns the full path, suitable for use with <a href> rather
 * than <Link to>, since these links are external and typically open
 * in new windows
 */
export function getAuthenticatedRedirectLink(url: string): string {
  const params = new URLSearchParams();
  params.set("url", url);

  return `${getBasePathWithTrailingSlash()}redirect?${params.toString()}`;
}
